module.exports = __webpack_public_path__ + "media/customizations/creekhavenlife/logo-new-8af9f3cf3e3f20cf054cea294d40e693.png";